export enum UserStatus {
  Pending = 10,
  Approved = 20,
  Rejected = 30,
}
